import {request} from '@/axios'

/**
 * @description 查詢当前系统(服务端)时间
 */
export function getSystemTime() {
  return request({
    url: '/basic/time/current',
    method: 'get'
  })
}

/**
 * @description 获取允许发起下单的时间段
 */
export function getLegalTimes() {
  return request({
    url: '/match/quick/config',
    method: 'get'
  })
}

/**
 * @description 查詢用戶正在進行的極速約單
 */
export function getMyOrderInfo() {
  return request({
    url: '/match/quick/doing',
    method: 'get'
  })
}

/**
 * @description 查詢匹配單技能
 */
export function getGrabOrderSkill() {
  return request({
    url: '/game/list/quick/match',
    method: 'get'
  })
}

/**
 * @description 創建匹配單之前，校驗時間，數量
 */
export function createCheckout() {
  return request({
    url: '/match/quick/create/checkout',
    method: 'get'
  })
}

/**
 * @description 創建匹配單
 * @param {Object} data
 */
export function createGrabOrder(data) {
  return request({
    url: '/match/quick/create',
    method: 'post',
    data
  })
}

/**
 * @description 查詢匹配單
 * @param {Object} parmas
 */
export function getGrabOrderDetail(params) {
  return request({
    url: '/match/quick/detail',
    method: 'get',
    params
  })
}

/**
 * @description 取消匹配
 * @param { Object } data
 */
export function cancelGrabOrder(data) {
  return request({
    url: '/match/quick/cancel',
    method: 'post',
    data
  })
}

/**
 * @description 完成匹配
 * @param {data} data
 */
export function finishGrabOrder(data) {
  return request({
    url: '/match/quick/finish',
    method: 'post',
    data
  })
}

/**
 * @description 約單按鈕-优惠券文案
 */
export function getButtonCouponTxt() {
  return request({
    url: '/match/quick/credit/display/content',
    method: 'get'
  })
}

/**
 * @description 查询约单
 * @param {Object} params
 */
export function getQuickOrderList(params) {
  return request({
    url: '/match/quick/list',
    method: 'get',
    params
  })
}

/**
 * @description 關注/取關用戶
 * @param {Object} data
 */
export function followUser(data) {
  return request({
    url: '/user/follow/operation',
    method: 'post',
    data
  })
}

/**
 * @description 获取用户上次成功的极速约单
 * @param {Object} data
 */
export function getLastQuickSuccess() {
  return request({
    url: '/match/quick/getLastQuickMatch',
    method: 'get'
  })
}

